export default __webpack_public_path__ + "high_coverage_ses_bc.png";